export const LocalStorageKey = {
  UserCurrentProfile: 'mycanal::currentProfile',
  UserProfiles: 'mycanal::profiles',
  UserProfilesUpdateDate: 'mycanal::profilesUpdateDate',
} as const;
